import { ENRICH_STATE_PATHS_TO_PERSIST_IN_LOCAL_STORAGE } from '@groupby/enrich-console';
import persistSubsetSelector from '@/store/selectors/persist';
export const USER_PROFILE_CACHE_KEY = 'cc-user-profile-cache';
export const COOKIE_CONSENT_KEY = 'cc-cookie-consent';
export const COOKIE_CONSENT_TTL_MS = 30 * 24 * 60 * 60 * 1000; // 30 days (pending legal confirmation)
export const CURRENT_CONSENT_VERSION = 2; // bump to force re-consent after policy changes
export const GTM_CONTAINER_ID = 'GTM-KSSS5ZL';
export function isConsentValid(record) {
    if (record == null) {
        return false;
    }
    return record.expiresAt > Date.now() && record.version === CURRENT_CONSENT_VERSION;
}
export const STATE_PATHS_TO_PERSIST = [
    ...ENRICH_STATE_PATHS_TO_PERSIST_IN_LOCAL_STORAGE,
];
export const ls = {
    getItem: (key) => {
        try {
            const data = localStorage.getItem(key);
            return JSON.parse(data);
        }
        catch (e) {
            void e;
        }
    },
    setItem: (key, value) => {
        try {
            const serialized = JSON.stringify(value);
            localStorage.setItem(key, serialized);
        }
        catch (e) {
            void e;
        }
    },
    clear(key) {
        try {
            if (key) {
                localStorage.removeItem(key);
            }
            else {
                localStorage.clear();
            }
        }
        catch (e) {
            void e;
        }
    },
};
export function persist(state, key) {
    const value = persistSubsetSelector(state, STATE_PATHS_TO_PERSIST);
    ls.setItem(key, value);
}
